// InvoiceHeader.tsx
// Displays the header of the invoice (green area), including the company name, phone number, and address.

import React from "react";

import { InvoiceCompanyHeaderInfo } from "../../../../bitmaker/schemas/Billing/Invoice";

interface InvoiceHeaderProps {
  displayInfo: InvoiceCompanyHeaderInfo | null;
}

export const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({
  displayInfo,
}) => {
  if (!displayInfo) return null;

  const companyName =
    displayInfo.companyCorporateName || displayInfo.companyName;

  const companyPhone = displayInfo.companyPhoneNumber ?? null;

  const buildFormattedAddress = () => {
    const {
      companyAddressLine,
      companyTownCity,
      companyStateProvince,
      companyPostalCode,
      companyCountry,
    } = displayInfo;

    const lines: string[] = [];

    if (companyAddressLine) {
      lines.push(companyAddressLine);
    }

    const secondLine: string[] = [];

    if (companyTownCity) {
      secondLine.push(companyTownCity);
    }

    const statePostal: string[] = [];
    if (companyStateProvince) statePostal.push(companyStateProvince);
    if (companyPostalCode) statePostal.push(companyPostalCode);

    if (statePostal.length) {
      secondLine.push(
        secondLine.length
          ? `, ${statePostal.join(" ")}`
          : statePostal.join(" "),
      );
    }

    if (secondLine.length) {
      lines.push(secondLine.join(""));
    }

    if (companyCountry) {
      lines.push(companyCountry);
    }

    return lines;
  };

  const formattedAddressLines = buildFormattedAddress();

  return (
    <div className="bg-green-600 text-white px-10 py-6 rounded-t-xl">
      <div className="grid grid-cols-2">
        {/* Column 1: Name and Telephone (Left Aligned) */}
        <div className="text-left">
          <div className="text-xl">{companyName}</div>
          {companyPhone && <div className="text-sm">{companyPhone}</div>}
        </div>

        {/* Column 2: Address (Right Aligned) */}
        <div className="text-right text-sm">
          {formattedAddressLines.length > 0 &&
            formattedAddressLines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
        </div>
      </div>
    </div>
  );
};
